import { Box, Flex } from '@chakra-ui/react'
import { FiList } from 'react-icons/fi'
import { TiVideo } from 'react-icons/ti'
import { MdChecklist } from 'react-icons/md'
import { TbBrandZoom, TbMessage2Question } from 'react-icons/tb'
import { TfiWrite } from "react-icons/tfi";


export default function DsrCreatePostTypeButton({ type, handleSelectSubpage, handleOpenNewPostModal, isProductMarketing, handleOpenSignupOrLoginModal, isMobileView }) {

  let userActionRequired = '';
  let icon = "";
  let labelName = "";

  switch (type) {
    case ('write-post'): {
      icon = TfiWrite;
      labelName = "Write a post";
      userActionRequired = "create-new-post";
      break;
    }
    // case('upload-image'): {
    //   icon= IoMdImages;
    //   labelName="Upload";
    //   userActionRequired="create-new-post";
    //   break;
    // }
    case ('ask-question'): {
      icon = TbMessage2Question;
      labelName = "Ask question";
      userActionRequired = "create-faq-question";
      break;
    }
    // case('post-poll'): {
    //   icon= FaPoll;
    //   labelName="Poll";
    //   userActionRequired="show-sales-cta";
    //    break;
    // }
    // case('make-voice-post'): {
    //   icon= MdKeyboardVoice;
    //   labelName="Voice";
    //   userActionRequired="show-sales-cta";
    //    break;
    // }
    case ('make-video-post'): {
      icon = TiVideo;
      labelName = "Video";
      userActionRequired = "create-video-post";
      break;
    }
    case ('record-loom-video-decoy'): {
      icon = TbBrandZoom;
      labelName = "Record";
      break;
    }
    case ('create-action-item-decoy'): {
      icon = FiList;
      labelName = "Assign action";
      break;
    }
    case ('create-action-item'): {
      return (
        <Flex 
          align='center' justify='center' px='0.5em' cursor='pointer'
          rounded='0.5em'
          gap='0.75em'
          _hover={{ bg: "brand.50" }}
          transition='all 0.1s ease-in-out'
          onClick={() => handleSelectSubpage("", 'action-list-subpage')}>
          <Box as={MdChecklist} boxSize={['1em', "1.2em"]} color='brand.500'/>
          <Box fontSize={['0.8em', '1em']} white-space="pre">Assign action</Box>
        </Flex>
      )
    }
    default: {
      console.log('There is no such button type:', type)
      break;
    }
  }

  if (isProductMarketing) {
    return (
      <Flex align='center' justify='center' gap='0.75em' px='0.5em' cursor='pointer' onClick={() => handleOpenSignupOrLoginModal()}>
        <Box as={icon} boxSize={['1em', "1.2em"]} color='brand.500' />
        <Box fontSize={['0.8em', '1em']}>{labelName}</Box>
      </Flex>
    )
  } else if (icon && labelName) {
    return (
        <Flex align='center' justify='center' p='0.5em' cursor='pointer' rounded='0.5em'
          gap='0.75em'
          _hover={{ bg: "brand.50" }}
          transition='all 0.2s ease-in-out'
          onClick={() => handleOpenNewPostModal(userActionRequired)}>
          <Box as={icon} boxSize={['1em', "1.2em"]}  color='brand.500' />
          <Box fontSize={['0.8em', '1em']}>{labelName}</Box>
        </Flex>
    );
  } else return null;


}
